(self["webpackChunktom_bihn"] = self["webpackChunktom_bihn"] || []).push([[754],{

/***/ 464:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initFileRouter)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


/**
 * This is the main entry point for all of the bundle JS.
 * You can immediately hook up an HTML element by using one of the two specified categories:
 * [data-utility] or [data-component]
 * The JS file will run with the specified element being passed in as the wrapper
 * You need to attach a specific file path as the attribute value [data]
 *
 * @example
 *   <button
 *     data-utility="link-to"
 *     data-link="/blog/your-url"
 *   >
 *     Click me
 *   </button>
 *
 * You can also pass multiple file paths by comma separating them
 * @example
 *   <button
 *     data-utility="link-to,inline-toggle"
 *     data-link="/blog/your-url"
 *     data-toggle="#some-query"
 *   >
 *     Click me
 *   </button>
 *
 * File paths can also include a subfolder
 * @example
 *   <button data-utility="button/atc">
 *     Click me
 *   </button>
 */

// Instructs the system of which attributes to watch for
function initFileRouter() {
  const watchForSelectors = [
    { path: 'utilities', selector: '[data-utility]' },
    { path: 'components', selector: '[data-component]' },
    { path: 'utilities', selector: '[class*="reveal"]', fileName: 'reveal' },
  ]

  watchForSelectors.forEach(watchForFile)
}

// Watches for and provided selector, then imports the related file
function watchForFile({ selector, path, fileName }) {
  const $watchContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()(document)

  $watchContainer.watchFor(selector, ($elements) => {
    if (!$elements.length) return

    $elements.each(function () {
      const targetElement = this
      const attribute = selector.replace('[', '').replace(']', '')
      const fileHandle = fileName || jquery__WEBPACK_IMPORTED_MODULE_0___default()(targetElement).attr(attribute)
      const splitHandles = fileHandle.split(',')

      splitHandles.forEach(function (handle) {
        importFile({ path, fileName: handle, element: targetElement })
      })
    })
  })
}

// Imports a file based on the provided path and file name
function importFile({ path, fileName, element }) {
  __webpack_require__(540)(`./${path}/${fileName}`).then(({ default: defaultFunction }) => {
    defaultFunction({ wrapper: element })
  })
}


/***/ }),

/***/ 540:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./app/": [
		464,
		9
	],
	"./app/barba": [
		694,
		9,
		162,
		694
	],
	"./app/barba.js": [
		694,
		9,
		162,
		694
	],
	"./app/config": [
		484,
		9
	],
	"./app/config.js": [
		484,
		9
	],
	"./app/index": [
		464,
		9
	],
	"./app/index.js": [
		464,
		9
	],
	"./components/accordion-group": [
		179,
		9,
		765
	],
	"./components/accordion-group.js": [
		179,
		9,
		765
	],
	"./components/account/account-confirmation-message": [
		415,
		9,
		415
	],
	"./components/account/account-confirmation-message.js": [
		415,
		9,
		415
	],
	"./components/account/address-form": [
		768,
		9,
		768
	],
	"./components/account/address-form.js": [
		768,
		9,
		768
	],
	"./components/afterpay": [
		266,
		7,
		266
	],
	"./components/afterpay.js": [
		266,
		7,
		266
	],
	"./components/dialog": [
		113,
		9,
		113
	],
	"./components/dialog.js": [
		113,
		9,
		113
	],
	"./components/global/navbar": [
		599,
		9,
		599
	],
	"./components/global/navbar.js": [
		599,
		9,
		599
	],
	"./components/global/overlay": [
		416,
		9,
		416
	],
	"./components/global/overlay.js": [
		416,
		9,
		416
	],
	"./components/global/predictive-search": [
		28,
		9,
		28
	],
	"./components/global/predictive-search.js": [
		28,
		9,
		28
	],
	"./components/global/slide-cart": [
		586,
		9,
		586
	],
	"./components/global/slide-cart-new": [
		521,
		9,
		521
	],
	"./components/global/slide-cart-new.js": [
		521,
		9,
		521
	],
	"./components/global/slide-cart.js": [
		586,
		9,
		586
	],
	"./components/klaviyo-form": [
		325,
		9,
		325
	],
	"./components/klaviyo-form.js": [
		325,
		9,
		325
	],
	"./components/marquee": [
		625,
		9,
		625
	],
	"./components/marquee.js": [
		625,
		9,
		625
	],
	"./components/product/back-in-stock": [
		717,
		9,
		717
	],
	"./components/product/back-in-stock.js": [
		717,
		9,
		717
	],
	"./components/product/bundler": [
		570,
		9,
		855,
		570
	],
	"./components/product/bundler.js": [
		570,
		9,
		855,
		570
	],
	"./components/product/buy-panel": [
		420,
		9,
		420
	],
	"./components/product/buy-panel.js": [
		420,
		9,
		420
	],
	"./components/product/lightbox": [
		926,
		9,
		855,
		926
	],
	"./components/product/lightbox.js": [
		926,
		9,
		855,
		926
	],
	"./components/product/product": [
		847,
		9,
		855,
		847
	],
	"./components/product/product-atc": [
		156,
		9,
		156
	],
	"./components/product/product-atc.js": [
		156,
		9,
		156
	],
	"./components/product/product-options": [
		991,
		9,
		991
	],
	"./components/product/product-options-2": [
		792,
		9,
		792
	],
	"./components/product/product-options-2.js": [
		792,
		9,
		792
	],
	"./components/product/product-options.js": [
		991,
		9,
		991
	],
	"./components/product/product-price": [
		780,
		9,
		780
	],
	"./components/product/product-price.js": [
		780,
		9,
		780
	],
	"./components/product/product-related": [
		628,
		9,
		628
	],
	"./components/product/product-related.js": [
		628,
		9,
		628
	],
	"./components/product/product.js": [
		847,
		9,
		855,
		847
	],
	"./components/quantity-box": [
		225,
		9,
		225
	],
	"./components/quantity-box.js": [
		225,
		9,
		225
	],
	"./components/recipient-fields": [
		322,
		9,
		322
	],
	"./components/recipient-fields.js": [
		322,
		9,
		322
	],
	"./components/reviews-reel": [
		758,
		9,
		758
	],
	"./components/reviews-reel.js": [
		758,
		9,
		758
	],
	"./components/site-gate": [
		26,
		9,
		26
	],
	"./components/site-gate.js": [
		26,
		9,
		26
	],
	"./components/slick-slider": [
		255,
		9,
		855,
		255
	],
	"./components/slick-slider.js": [
		255,
		9,
		855,
		255
	],
	"./components/sticky-nav": [
		723,
		9,
		475
	],
	"./components/sticky-nav.js": [
		723,
		9,
		475
	],
	"./components/swiper": [
		708,
		9,
		630,
		708
	],
	"./components/swiper.js": [
		708,
		9,
		630,
		708
	],
	"./components/video-player": [
		131,
		9,
		131
	],
	"./components/video-player.js": [
		131,
		9,
		131
	],
	"./elements/": [
		891,
		9,
		891
	],
	"./elements/index": [
		891,
		9,
		891
	],
	"./elements/index.js": [
		891,
		9,
		891
	],
	"./elements/os-select": [
		439,
		9,
		439
	],
	"./elements/os-select.js": [
		439,
		9,
		439
	],
	"./utilities/inline-toggle": [
		326,
		9,
		326
	],
	"./utilities/inline-toggle.js": [
		326,
		9,
		326
	],
	"./utilities/link-to": [
		959,
		9,
		959
	],
	"./utilities/link-to.js": [
		959,
		9,
		959
	],
	"./utilities/password-toggle": [
		756,
		9,
		756
	],
	"./utilities/password-toggle.js": [
		756,
		9,
		756
	],
	"./utilities/reveal": [
		431,
		9,
		431
	],
	"./utilities/reveal.js": [
		431,
		9,
		431
	],
	"./utilities/scroll-toggle": [
		202,
		9,
		202
	],
	"./utilities/scroll-toggle.js": [
		202,
		9,
		202
	],
	"./utilities/scroll-trigger": [
		662,
		9,
		662
	],
	"./utilities/scroll-trigger.js": [
		662,
		9,
		662
	],
	"./utilities/section-nav": [
		365,
		9,
		365
	],
	"./utilities/section-nav.js": [
		365,
		9,
		365
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 540;
module.exports = webpackAsyncContext;

/***/ })

}]);